import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import {
  Vuetify,
  VAlert,
  VApp,
  VAutocomplete,
  VAvatar,
  VBadge,
  VBottomSheet,
  VBtn,
  VBtnToggle,
  VCard,
  VCheckbox,
  VChip,
  VCombobox,
  VDataIterator,
  VDataTable,
  VDatePicker,
  VDialog,
  VDivider,
  VExpansionPanel,
  VFooter,
  VForm,
  VGrid,
  VHover,
  VIcon,
  VImg,
  VList,
  VMenu,
  VNavigationDrawer,
  VPagination,
  VProgressCircular,
  VProgressLinear,
  VRadioGroup,
  VSelect,
  VSnackbar,
  VSpeedDial,
  VStepper,
  VSubheader,
  VSwitch,
  VTabs,
  VTextField,
  VToolbar,
  VTooltip,
  VTreeview,
  transitions
} from 'vuetify'

import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VAlert,
    VApp,
    VAutocomplete,
    VAvatar,
    VBadge,
    VBottomSheet,
    VBtn,
    VBtnToggle,
    VCard,
    VCheckbox,
    VChip,
    VCombobox,
    VDataIterator,
    VDataTable,
    VDatePicker,
    VDialog,
    VDivider,
    VExpansionPanel,
    VFooter,
    VForm,
    VGrid,
    VHover,
    VIcon,
    VImg,
    VList,
    VMenu,
    VNavigationDrawer,
    VPagination,
    VProgressCircular,
    VProgressLinear,
    VRadioGroup,
    VSelect,
    VSnackbar,
    VSpeedDial,
    VStepper,
    VSubheader,
    VSwitch,
    VTabs,
    VTextField,
    VTreeview,
    VToolbar,
    VTooltip,
    transitions
  },
  iconfont: 'mdi',
  theme: {
    // primary: '#006064',
    primary: process.env.NODE_ENV === 'production' ? '#3e7fc2' : '#f44336',
    secondary: '#607D8B',
    accent: '#03b795',
    error: '#f44336',
    warning: '#FF9800',
    info: '#2196f3',
    success: '#4caf50'
  }
})
